import { render, staticRenderFns } from "./ContentBlogList.vue?vue&type=template&id=06bac505&scoped=true&"
import script from "./ContentBlogList.vue?vue&type=script&lang=js&"
export * from "./ContentBlogList.vue?vue&type=script&lang=js&"
import style0 from "./ContentBlogList.vue?vue&type=style&index=0&id=06bac505&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bac505",
  null
  
)

export default component.exports